module.exports = __webpack_public_path__ + "img/banner.7d203394.png";